import { render, staticRenderFns } from "./FormExhibition.vue?vue&type=template&id=68d1298e&"
import script from "./FormExhibition.vue?vue&type=script&lang=js&"
export * from "./FormExhibition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports